import MainLayout from "../layout/MainLayout";
import { Button1, EmptyScreen } from "../Components";
import { useNavigate } from "react-router-dom";

const Reports = () => {
  const navigate = useNavigate();
  return (
    <MainLayout NavName="Report" expand={false}>
      <div>
        <div className="container mt-4">
          <EmptyScreen
            heading="Reports"
            message="Generate statements, spending summaries, and budget reports from here."
            messageWidth="420px"
            headingWidth="360px"
            moreContent={
              <div className="d-flex gap-2 justify-content-center flex-wrap mt-3">
                <Button1
                  buttonName="View Statements"
                  className="btn-outline-success"
                  onClick={() => navigate("/statement")}
                />
                <Button1
                  buttonName="Spending Report"
                  className="btn-outline-success"
                  onClick={() => navigate("/spending-report")}
                />
                <Button1
                  buttonName="Budget Report"
                  className="btn-dark text-white"
                  onClick={() => navigate("/budget-report")}
                />
              </div>
            }
          />
        </div>
      </div>
    </MainLayout>
  );
};

export default Reports;
